import type { ArtistWorkHistory } from '@customTypes/types';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Space, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { getDateDifference } from '@/shared/helper/getDateDifference';
import { translate } from '@/shared/i18n/translate';
import { LBLinkButton } from '@/shared/ui-kit/components';

import styles from './PortfolioItemCard.module.css';

type PortfolioItemCardProps = ArtistWorkHistory & {
  onDelete?: () => void;
};

export const PortfolioItemCard = ({
  clubName,
  clubCountry,
  jobRole,
  onDelete,
  startDate,
  endDate,
  lbVerified,
  untilNow
}: PortfolioItemCardProps) => {
  const intl = useIntl();

  // Format dates to European format (DD.MM.YYYY)
  const formattedStartDate = dayjs(startDate).format('DD.MM.YYYY');
  const formattedEndDate = endDate ? dayjs(endDate).format('DD.MM.YYYY') : null;

  return (
    <div className={styles.container}>
      {/* Verifying block aligned right  */}
      {lbVerified && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '8px',
            minHeight: '18px', // reserve space for verified block
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Text c='dimmed' fz={12} style={{ textAlign: 'right' }}>
              verified by
            </Text>
            <div
              className={styles.spin}
              style={{
                backgroundImage: `url('/maskable_192.png')`,
                borderRadius: '50%',
                padding: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '30px',
                height: '30px',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                overflow: 'hidden',
                flexShrink: 0
              }}
            />
          </div>
        </div>
      )}
      <div style={{ paddingTop: lbVerified ? 0 : 25 }}>
      <Text fw={600}>{clubName}</Text>
      <Space h={8} />
      <Text c='#f74360' fz={14}>
        {translate(`commons.artistJobs.${jobRole}`)}
      </Text>
      <Space h={8} />
      <Text c='gray' fz={14}>
        {clubCountry}
      </Text>
      <Space h={4} />

      <Text c='gray' fz={14}>
        <span style={{ color: '#000' }}>&#8226;&nbsp;</span>
        {formattedStartDate} - {!endDate ? translate('commons.untilNow') : formattedEndDate}
      </Text>
      <Space h={4} />

      {!untilNow && (
        <Text c='gray' fz={14}>
          {!untilNow && (
            <Text c='black' fz={14}>
              {getDateDifference(startDate, endDate, intl)}
            </Text>
          )}
        </Text>
      )}
      <Space h={16} />
      {onDelete && (
        <LBLinkButton leftsection={<TrashIcon width={18} />} onClick={onDelete}>
          {translate('commons.delete')}
        </LBLinkButton>
      )}
    </div>
    </div>
  );
};
